export default "__VITE_ASSET__BGalgvEE__"